import React, { useState, useEffect } from 'react';
import { Container, Button } from 'react-bootstrap';
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';

import { useDispatch, useSelector } from 'react-redux';
import { setEmbryologyData } from '../../../../actions/embryologyActions';
import {
  fetchEmbryologyFreezingInventory,
  saveEmbryologyFreezingInventory,
} from '../../../../api/embryologyApi';
import { toast } from 'sonner';
import dayjs from 'dayjs';
import { deleteNotification } from '../../../../api/notificationsApi';
import DeleteModal from '../../../Notifications/DeleteModal';
import FileUploadCard from '../../../../components/FileManager/FileUploadCard';
import FileDocumentCard from '../../../../components/FileManager/FileDocumentCard';
import { deleteFileApi } from '../../../../api/fileApi';
import {
  updateFileStatusUploaded,
  uploadPatientFileApi,
} from '../../../../api/patientApi';
const emptyModalState = {
  open: false,
  title: '',
  body: '',
  proceedText: '',
  cancelText: '',
  onSave: null,
  onClose: null,
  needsComments: false,
};

const EmbryologyFreezingInventory = ({ isNotifications }) => {
  const [modalOpen, setModalOpen] = useState({
    open: false,
    title: '',
    body: '',
    proceedText: '',
    cancelText: '',
    onSave: null,
    onClose: null,
    needsComments: false,
  });
  const [files, setFiles] = useState([]);
  const handleDeleteInventory = (notification, deleteComment) => {
    console.log(notification, deleteComment);
    if (deleteComment === '' || deleteComment === null) {
      toast.error('Please enter a reason for deletion');
      return;
    }
    toast.promise(
      deleteNotification(
        selectedPatientData.id,
        notification.id,
        'embryo',
        deleteComment,
      )
        .then((response) => {
          console.log(response);
          setModalOpen({ ...emptyModalState });
        })
        .then(() => {
          fetchFreezingInventory();
        }),
      {
        loading: 'Deleting notification...',
        success: 'Notification deleted successfully',
        error: 'Failed to delete notification',
      },
    );
  };
  const emptyRow = {
    dateOfOpu: '',
    dayOfCryopreservation: '',
    numberOfCryoDevice: '',
    numberOfEmbryos: '',
    dateOfThawing: '',
    numberOfCryoDeviceThawed: '',
    numberOfEmbryosThawed: '',
  };

  const selectedPatientData = useSelector(
    (state) => state.embryologyReducer.selectedPatientData.patient,
  );

  const freezingInventory = useSelector(
    (state) => state.embryologyReducer.freezingInventory,
  );

  const [renew, setRenew] = useState(false);

  console.log(freezingInventory);

  const handleAddRow = () => {
    const oldRows = [...freezingInventory.data];
    oldRows.push(emptyRow);
    dispatch(
      setEmbryologyData({
        ...freezingInventory,
        data: oldRows,
      }),
    );
  };

  const dispatch = useDispatch();

  const handleChange = (index, field, value) => {
    console.log(index, field, value);
    const oldRows = [...freezingInventory.data];
    oldRows[index][field] = value;
    dispatch(
      setEmbryologyData('freezingInventory', {
        ...freezingInventory,
        data: oldRows,
      }),
    );
  };

  const handleUpload = async (file, patientId) => {
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          uploadPatientFileApi(
            file,
            selectedPatientData.id,
            'Patient',
            updateFileStatusUploaded,
            'SemenFreezingInventory',
          ),
          {
            loading: 'Uploading file...',
            success: (data) => {
              setUploadedFiles({
                file: data,
                fileTag: 'EmbryoFreezingInventory',
              });

              return resolve(data);
            },
            error: (err) => {
              reject('Failed to upload docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        toast.error('Failed to upload file');
      }
    });
  };

  const handleDurationChange = (field, value) => {
    dispatch(
      setEmbryologyData('freezingInventory', {
        ...freezingInventory,
        [field]: value,
      }),
    );
    if (
      field === 'freezingDurationYears' ||
      field === 'freezingDurationMonths'
    ) {
      const updatedValue = value || 0;
      let years =
        field === 'freezingDurationYears'
          ? updatedValue
          : freezingInventory.freezingDurationYears || 0;
      let months =
        field === 'freezingDurationMonths'
          ? updatedValue
          : freezingInventory.freezingDurationYears || 0;
      years = parseInt(years, 10);
      months = parseInt(months, 10);
      const totalMonths = years * 12 + months;
      const date = new Date();
      date.setMonth(date.getMonth() + totalMonths);
      dispatch(
        setEmbryologyData(
          'freezingInventory.dateOfExpiry',
          date.toISOString().split('T')[0],
        ),
      );
    }
  };

  const fetchFreezingInventory = async () => {
    try {
      const response = await fetchEmbryologyFreezingInventory(
        selectedPatientData.id,
      );
      if (!response.data.result.freezingInventory.inventory) {
        const summary = response.data.result.freezingInventory.summary;
        const oocyteEmbryoRecord =
          response.data.result.freezingInventory.oocyteEmbryoRecord;
        const cryopreservation =
          response.data.result.freezingInventory.cryopreservation;
        const summaryLength = summary ? summary.length : 0;
        const expiry = {
          dateOfExpiry: '',
          freezingDurationYears: '',
          freezingDurationMonths: '',
        };
        const rows = [];
        for (let i = 0; i < summaryLength; i++) {
          rows.push({
            ...emptyRow,
            cycleId: summary[i].cycleId,
          });

          rows[i].dateOfOpu = dayjs(summary[i].summary.date).format(
            'YYYY-MM-DD',
          );
        }
        let totalEmbryos = 0;
        let totalEmbryosThawed = 0;
        let totalCryoDevice = 0;
        let totalCryoDeviceThawed = 0;
        for (let i = 0; i < cryopreservation.length; i++) {
          const index = rows.findIndex(
            (row) => row.cycleId === cryopreservation[i].cycleId,
          );
          let totalNumberOfCryoDevice = 0;
          let totalNumberOfEmbryos = 0;
          let numberOfCryoDeviceThawed = 0;
          let numberOfEmbryosThawed = 0;
          console.log(index);
          if (index !== -1) {
            const initialData =
              cryopreservation[i].cryopreservation.initialData;
            console.log(initialData, 'initialData');
            if (initialData && initialData.data.length > 0) {
              totalNumberOfEmbryos +=
                initialData.data[0].numberOfOocytesOrEmbryos;
              totalNumberOfCryoDevice += 1;
              rows[index].dayOfCryopreservation = initialData.data[0].day;
              rows[index].numberOfCryoDevice = initialData.data.length;
              rows[index].numberOfEmbryos = initialData.data.reduce(
                (acc, curr) => acc + curr.numberOfOocytesOrEmbryos,
                0,
              );

              const freezingLocation =
                cryopreservation[i].cryopreservation.freezingLocation;
              if (freezingLocation) {
                expiry.dateOfExpiry = dayjs(freezingLocation.expiryDate).format(
                  'YYYY-MM-DD',
                );
                expiry.freezingDurationMonths =
                  freezingLocation.durationOfCryopreservationMonths;
                expiry.freezingDurationYears =
                  freezingLocation.durationOfCryopreservationYears;
              }

              const thawingDetails =
                cryopreservation[i].cryopreservation.thawingDetails;
              if (thawingDetails && thawingDetails.data.length > 0) {
                for (let j = 0; j < thawingDetails.data.length; j++) {
                  if (thawingDetails.data[j].thawingDate) {
                    rows[i].dateOfThawing = dayjs(
                      thawingDetails.data[j].thawingDate,
                    ).format('YYYY-MM-DD');
                    numberOfCryoDeviceThawed += 1;
                    numberOfEmbryosThawed +=
                      initialData.data[j].numberOfOocytesOrEmbryos;
                  }
                }
              }
            }
            rows[index].numberOfCryoDeviceThawed = numberOfCryoDeviceThawed;
            rows[index].numberOfEmbryosThawed = numberOfEmbryosThawed;
            totalEmbryos += totalNumberOfEmbryos;
            totalCryoDevice += totalNumberOfCryoDevice;
            totalEmbryosThawed += numberOfEmbryosThawed;
            totalCryoDeviceThawed += numberOfCryoDeviceThawed;
          }
        }
        const remainingCryoDevice = totalCryoDevice - totalCryoDeviceThawed;
        const remainingEmbryos = totalEmbryos - totalEmbryosThawed;

        dispatch(
          setEmbryologyData('freezingInventory', {
            ...expiry,
            data: rows,
            remainingCryoDevice,
            remainingEmbryos,
          }),
        );

        toast.success('Freezing Inventory fetched successfully');
      } else {
        const freezingInventory =
          response.data.result.freezingInventory.inventory.freezingInventory;
        const isNotificationRemoved =
          response.data.result.freezingInventory.inventory
            .isNotificationRemoved;
        const notificationDeletionComments =
          response.data.result.freezingInventory.inventory
            .notificationDeletionComments;

        freezingInventory.isNotificationRemoved = isNotificationRemoved;
        freezingInventory.notificationDeletionComments =
          notificationDeletionComments;
        freezingInventory.id =
          response.data.result.freezingInventory.inventory.id;

        dispatch(setEmbryologyData('freezingInventory', freezingInventory));
      }
    } catch (e) {
      console.log('error', e);
      toast.error('Failed to fetch Freezing Inventory');
    }
  };

  const handleDeleteFile = async (file, patientId) => {
    return new Promise((resolve, reject) => {
      try {
        toast.promise(
          deleteFileApi('patient', selectedPatientData.id, file.id),
          {
            loading: 'Deleting file...',
            success: (data) => {
              setUploadedFiles(null);

              return resolve(data);
            },
            error: (err) => {
              reject('Failed to delete docs');
            },
            duration: 100,
          },
        );
      } catch (err) {
        toast.error('Failed to delete file');
      }
    });
  };

  const setUploadedFiles = async (file) => {
    console.log(file);
    try {
      const files = freezingInventory.files || [];
      if (file) {
        files.push(file);
      }

      const data = {
        id: freezingInventory.id,
        ...freezingInventory,
        data: freezingInventory.data,
        files: file ? files : [],
      };
      const response = await saveEmbryologyFreezingInventory(
        selectedPatientData.id,
        data,
      );

      fetchFreezingInventory();
    } catch (e) {
      console.log('error', e);
    }
  };

  useEffect(() => {
    fetchFreezingInventory();
  }, []);

  return (
    <Container className="mt-5">
      {modalOpen.open && <DeleteModal modalOpen={modalOpen} />}
      <Typography variant="h6" gutterBottom>
        Embryo Freezing Inventory
      </Typography>
      <Paper className="p-3 mb-3">
        <TableContainer component={Paper} sx={{ padding: '2px' }}>
          <Table>
            <TableBody>
              {[
                'dateOfOpu',
                'dayOfCryopreservation',
                'numberOfCryoDevice',
                'numberOfEmbryos',
                'dateOfThawing',
                'numberOfCryoDeviceThawed',
                'numberOfEmbryosThawed',
              ].map((field, fieldIndex) => (
                <TableRow key={fieldIndex}>
                  <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                    {field === 'dateOfOpu' && 'Date of OPU'}
                    {field === 'dayOfCryopreservation' &&
                      'Day of Cryopreservation'}
                    {field === 'numberOfCryoDevice' && 'Number of Cryo-Device'}
                    {field === 'numberOfEmbryos' && 'Number of Embryos'}
                    {field === 'dateOfThawing' && 'Thawing Date'}
                    {field === 'numberOfCryoDeviceThawed' &&
                      'Number of Cryo-Device Thawed'}
                    {field === 'numberOfEmbryosThawed' &&
                      'Number of Embryos Thawed'}
                    {field === 'remainingCryoDevice' && 'Remaining Cryo-Device'}
                    {field === 'remainingEmbryos' && 'Remaining Embryos/Oocyte'}
                  </TableCell>
                  {freezingInventory.data.map((row, index) => (
                    <TableCell key={index} style={{ padding: '6px' }}>
                      <TextField
                        className="custom-text-field"
                        type={
                          field.includes('date')
                            ? 'date'
                            : field.includes('day')
                              ? 'text'
                              : 'number'
                        }
                        InputLabelProps={
                          field.includes('date') ? { shrink: true } : {}
                        }
                        fullWidth
                        value={freezingInventory.data[index][field]}
                        onChange={(e) =>
                          handleChange(index, field, e.target.value)
                        }
                        sx={{
                          '& .MuiInput-underline:before': {
                            borderBottom: 'none',
                          },
                          '& .MuiInput-underline:after': {
                            borderBottom: 'none',
                          },
                        }}
                      />
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {freezingInventory.data.length > 5 ? (
          <></>
        ) : (
          <Button variant="primary" className="mt-3" onClick={handleAddRow}>
            + Add more
          </Button>
        )}
      </Paper>

      <Paper className="p-3 mb-3 mt-4">
        <TableContainer component={Paper}>
          <Table>
            <TableBody>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                  Remaining Cryo-Device
                </TableCell>
                <TableCell style={{ padding: '6px' }}>
                  <TextField
                    className="custom-text-field"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    value={freezingInventory.remainingCryoDevice}
                    onChange={(e) =>
                      handleDurationChange(
                        'remainingCryoDevice',
                        e.target.value,
                      )
                    }
                    sx={{
                      '& .MuiInput-underline:before': { borderBottom: 'none' },
                      '& .MuiInput-underline:after': { borderBottom: 'none' },
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                  Remaining Embryos
                </TableCell>
                <TableCell style={{ padding: '6px' }}>
                  <TextField
                    className="custom-text-field"
                    type="number"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    value={freezingInventory.remainingEmbryos}
                    onChange={(e) =>
                      handleDurationChange('remainingEmbryos', e.target.value)
                    }
                    sx={{
                      '& .MuiInput-underline:before': { borderBottom: 'none' },
                      '& .MuiInput-underline:after': { borderBottom: 'none' },
                    }}
                  />
                </TableCell>
              </TableRow>
              <TableRow>
                {renew && (
                  <>
                    <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                      Freezing Duration{' '}
                    </TableCell>

                    <TableCell style={{ padding: '6px' }}>
                      <TextField
                        className="custom-text-field"
                        type="number"
                        fullWidth
                        label="Years"
                        value={freezingInventory.freezingDurationYears}
                        onChange={(e) => {
                          handleDurationChange(
                            'freezingDurationYears',
                            e.target.value,
                          );
                        }}
                        sx={{
                          '& .MuiInput-underline:before': {
                            borderBottom: 'none',
                          },
                          '& .MuiInput-underline:after': {
                            borderBottom: 'none',
                          },
                        }}
                      />
                    </TableCell>
                    <TableCell style={{ padding: '6px' }}>
                      <TextField
                        className="custom-text-field"
                        type="number"
                        fullWidth
                        label="Months"
                        value={freezingInventory.freezingDurationMonths}
                        onChange={(e) =>
                          handleDurationChange(
                            'freezingDurationMonths',
                            e.target.value,
                          )
                        }
                        sx={{
                          '& .MuiInput-underline:before': {
                            borderBottom: 'none',
                          },
                          '& .MuiInput-underline:after': {
                            borderBottom: 'none',
                          },
                        }}
                      />
                    </TableCell>
                  </>
                )}
              </TableRow>
              <TableRow>
                <TableCell style={{ fontWeight: 'bold', padding: '6px' }}>
                  Date of Expiry
                </TableCell>
                <TableCell style={{ padding: '6px' }}>
                  <TextField
                    className="custom-text-field"
                    type="date"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    value={freezingInventory.dateOfExpiry}
                    onChange={(e) =>
                      handleDurationChange('dateOfExpiry', e.target.value)
                    }
                    sx={{
                      '& .MuiInput-underline:before': { borderBottom: 'none' },
                      '& .MuiInput-underline:after': { borderBottom: 'none' },
                    }}
                  />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>

        {!freezingInventory.isNotificationRemoved && (
          <>
            <Button
              variant="primary"
              className="mt-3"
              disabled={renew}
              onClick={() => setRenew(true)}
            >
              Renew
            </Button>

            <Button
              variant="primary"
              className="ml-3 mt-3"
              onClick={() =>
                setModalOpen({
                  open: true,
                  title: 'Discard Inventory',
                  body: 'Enter deletion comments',
                  proceedText: 'Delete',
                  cancelText: 'Cancel',
                  needsComments: true,
                  onSave: handleDeleteInventory,
                  notification: freezingInventory,
                  onClose: () => {
                    setModalOpen({ ...emptyModalState });
                  },
                })
              }
            >
              Discard
            </Button>
          </>
        )}

        {freezingInventory.isNotificationRemoved && (
          <>
            <Typography variant="body1" className="mt-3">
              Inventory Discarded
            </Typography>
            <Typography variant="body1" className="mt-3">
              Discard Comments: {freezingInventory.notificationDeletionComments}
            </Typography>
          </>
        )}

        {freezingInventory.isNotificationRemoved && (
          <div className="row clearfix">
            <FileUploadCard
              setFiles={setFiles}
              setUploadedFiles={setUploadedFiles}
              files={freezingInventory.files || []}
              handleUpload={handleUpload}
              id={selectedPatientData.id}
            />
            {freezingInventory.files &&
              freezingInventory.files.map((uploadedFile, i) => {
                const data = uploadedFile.file;

                if (uploadedFile.fileTag !== 'EmbryoFreezingInventory')
                  return null;
                return (
                  <FileDocumentCard
                    key={i}
                    DocumentName={data.displayFileName}
                    DocumentSize={(data.size / 1024).toFixed(2) + ' KB'}
                    DocumentDate={new Date(data.updatedAt).toLocaleDateString()}
                    ImageUrl={
                      data?.fileType?.includes('image')
                        ? data.presignedUrl
                        : undefined
                    }
                    handleDeleteFile={() => handleDeleteFile(data)}
                    file={data}
                    fileUniquePrefix={`patient-${selectedPatientData.id}`}
                  />
                );
              })}
          </div>
        )}
      </Paper>
    </Container>
  );
};

export default EmbryologyFreezingInventory;
